<template>
  <div>
    <div class="card" v-for="(item, index) in listingData" :key="item.id">
      <a :href="item.Url" class="details-arrow">
        <img src="../../../../Assets/Images/left-white-arrow.png" alt="arrow" />
      </a>
      <a class="card-body card-title">
        {{ item.ServiceName }}
      </a>

      <div
        :id="item.Id"
        class="collapse"
        :class="index == 0 || (index == 0 && mobileView) ? 'show' : ''"
        aria-labelledby="headingOne"
        data-parent="#accordionExample"
      >
        <div class="card-body">
          <div
            class="seprator"
            style="
              background-image: url('../../../../Assets/Images/seprator.svg');
            "
          ></div>

          <div class="row data">
            <div class="col-sm-12 col-lg-6">
              <div class="data__details">
                <div class="data__details__title">
                  {{ serviceCardObj.ServiceCost }}
                </div>
                <div class="data__details__description">
                  {{ item.ServiceFees || "-" }}
                </div>
              </div>
              <div class="data__details">
                <div class="data__details__title">
                  {{ serviceCardObj.CentralAdministration }}
                </div>
                <div class="data__details__description">
                  <div>{{ item.Sector || "-" }}</div>
                </div>
              </div>
              <div class="data__details">
                <div class="data__details__title">
                  {{ serviceCardObj.PublicAdministration }}
                </div>
                <div class="data__details__description">
                  {{ item.Department || "-" }}
                </div>
              </div>
              <div class="data__details">
                <div class="data__details__title">
                  {{ serviceCardObj.Specialization }}
                </div>
                <div class="data__details__description">
                  <span v-for="(func, index) in item.Functions" :key="index">
                    {{ func }}
                    <span v-if="index != item.Functions.length - 1">- </span>
                  </span>
                  <span v-if="!item.Functions">-</span>
                  <!-- <div v-for="(func, index) in item.Functions" :key="index">
                    {{ func }}
                  </div> -->
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-lg-6">
              <div class="data__details">
                <div class="data__details__title">
                  {{ serviceCardObj.Cosmetic }}
                </div>
                <div class="data__details__description">
                  <span
                    v-for="(health, index) in item.HealthProducts"
                    :key="index"
                    >{{ health }}
                    <span v-if="index != item.HealthProducts.length - 1"
                      >-
                    </span></span
                  >
                  <span v-if="!item.HealthProducts">-</span>
                  <!-- <div
                    v-for="(health, index) in item.HealthProducts"
                    :key="index"
                  >
                    {{ health }}
                  </div> -->
                </div>
              </div>

              <div class="data__details">
                <div class="data__details__title">
                  {{ serviceCardObj.SecondaryCategory }}
                </div>
                <div class="data__details__description">
                  {{ item.SubCategory || "-" }}
                </div>
              </div>

              <div class="data__details">
                <div class="data__details__title">
                  {{ serviceCardObj.Category }}
                </div>
                <div class="data__details__description">
                  {{ item.Category || "-" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header" id="headingOne">
        <h2 class="mb-0">
          <button
            class="btn btn-link btn-block text-center filterCollapse"
            type="button"
            data-toggle="collapse"
            :data-target="'#' + item.Id"
            aria-expanded="true"
            :aria-controls="item.Id"
          >
            <!-- <i class="icon-expand"></i> -->
            <div class="icon-wrapper">
              <div class="custom-icon-expand">
                <div class="custom-icon-expand__rect"></div>
                <div class="custom-icon-expand__triangle"></div>
              </div>

              <div class="custom-icon-collapse">
                <div class="custom-icon-collapse__triangle"></div>
                <div class="custom-icon-collapse__rect"></div>
              </div>
            </div>
          </button>
        </h2>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    serviceCardObj: {
      type: Object,
    },
    serviceCardArr: {
      type: Object,
    },
    mobileView: {
      type: Boolean,
    },
  },
  methods: {},
  computed: {
    listingData() {
      let lang = "ar-EG";
      if (location.pathname.includes("/en")) {
        lang = "en-us";
      }
      let serviceArray = JSON.parse(
        JSON.stringify(this.serviceCardArr.Services)
      );
      serviceArray.map((x) => {
        if (lang === "ar-EG") {
          x.ServiceFees = x.ServiceFees.replace(/[0-9]/gim, (number) =>
            parseInt(number).toLocaleString(lang)
          );
        }
      });
      return serviceArray;
    },
  },
};
</script>
